import { FC } from 'react'
import { Button, Col, Form, InputNumber, Modal } from 'components/common'
import { CustomizedModalProps } from './types'
import { DiscountFeeInput } from 'lib/graphql/storeadmin'
import { DiscountReason } from '../reuseable'
import clsx from 'clsx'

export interface BookingDiscountModalProps
  extends Omit<CustomizedModalProps, 'onOk'> {
  discountValue: DiscountFeeInput
  onOk: (values: DiscountFeeInput) => void
  onClose: (open: boolean) => void
}

type Discount = {
  discount?: number
  discountReason?: string
}

export const BookingDiscountModal: FC<BookingDiscountModalProps> = ({
  discountValue,
  open,
  onOk,
  onClose,
  ...rest
}) => {
  const [form] = Form.useForm<Discount>()
  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        onClose(false)
        onOk({ reason: values?.discountReason, value: values?.discount })
      })
      .catch(console.warn)
  }

  return (
    <Modal
      open={open}
      title="ディスカウントの変更"
      onOk={() => onSubmit()}
      onCancel={() => onClose(false)}
      footer={[
        <div
          className={clsx(
            discountValue?.value > 0 && discountValue?.reason !== ''
              ? 'flex justify-between m-2'
              : 'm-2'
          )}
        >
          {discountValue?.value > 0 && discountValue?.reason !== '' && (
            <div>
              <Button
                type="primary"
                key="resetForm"
                danger
                onClick={() => {
                  onClose(false)
                  form.setFieldsValue({
                    discount: undefined,
                    discountReason: '',
                  })
                  onOk({
                    reason: '',
                    value: undefined,
                  })
                }}
              >
                ディスカウントを削除
              </Button>
            </div>
          )}
          <div>
            <Button key="cancel" onClick={() => onClose(false)}>
              キャンセル
            </Button>
            <Button type="primary" key="submit" onClick={() => onSubmit()}>
              完了
            </Button>
          </div>
        </div>,
      ]}
      {...rest}
    >
      <Form form={form} name="discountFormInModal">
        <Col span={24}>
          <Form.Item
            name="discount"
            label="ディスカウントの金額"
            initialValue={discountValue?.value}
            rules={[{ required: true }]}
          >
            <InputNumber
              style={{ width: '100%' }}
              value={discountValue?.value ?? 0}
              min={0}
              formatter={(value) => `￥ ${value}`}
              parser={(value) => value.replace('￥', '')}
            />
          </Form.Item>
        </Col>

        <DiscountReason name="discountReason" reason={discountValue?.reason} />
      </Form>
    </Modal>
  )
}
